<div class="side-panel-direct-search-container">
    @if (isDSResultsShown) {
        <p class="sp-ds-form">In base alle seguenti scelte:</p>

        <app-direct-search-form [isResultsShown]="true"></app-direct-search-form>
    }
</div>